import React, { useCallback, useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { StyledAvatarStatus } from 'components/Shared/style';
import FeedItem from 'components/LeftMenu/Shared/FeedItem';

import { getUrl } from 'utils/url';
import { PRESENCE_STATUSES } from 'const/user';

const UnicastFeedItem = ({
    id,
    _anchor,
    onRemove,
    firstname,
    lastname,
    unreadCount,
    avatarUri,
    status,
    _currentFeed
}) => {
    const handleRemoveItem = useCallback(() => onRemove(_anchor), [onRemove, _anchor]);
    const isCurrent = id === _currentFeed;
    const renderItemIcon = useMemo(() => (
        <StyledAvatarStatus
            src={avatarUri}
            status={status}
            size="xs"
            alt={`${firstname} ${lastname}`}
        />
    ), [avatarUri, status, firstname, lastname]);

    return (
        <FeedItem
            id={id}
            onRemove={handleRemoveItem}
            iconRender={renderItemIcon}
            label={`${firstname} ${lastname}`}
            href={getUrl('feed', { _feed: id })}
            unreadCount={unreadCount}
            isCurrent={isCurrent}
        />
    );
}

UnicastFeedItem.propTypes = {
    id: PropTypes.string.isRequired,
    _anchor: PropTypes.string.isRequired,
    onRemove: PropTypes.func.isRequired,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    avatarUri: PropTypes.string,
    unreadCount: PropTypes.number,
    status: PropTypes.oneOf(Object.values(PRESENCE_STATUSES)),
    _currentFeed: PropTypes.string
};

export default memo(injectIntl(UnicastFeedItem));
